import { render } from "./NavigationControl.vue?vue&type=template&id=46aa35e9"
import script from "./NavigationControl.vue?vue&type=script&lang=js"
export * from "./NavigationControl.vue?vue&type=script&lang=js"

import "./NavigationControl.vue?vue&type=style&index=0&id=46aa35e9&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__